/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IBlockSchema } from '../../entities/block/BlockSchema';
import { IChartSchema } from '../../entities/chart/ChartSchema';

export type TGetChartModel = IModel<IGetChartRequest, TGetChartResponse>;

export interface IGetChartRequest {
  /** Значение фильтра «категория» для графика **/
  category?: ECategory | null;
  /** Значение фильтра «гео» для графика **/
  geoName?: EGeoName | null;
  /** Тип графика **/
  dataType?: EDataType | null;
}

export type TGetChartResponse = IGetChartResponse200 | IGetChartResponse400;

export interface IGetChartResponse200 extends IModelResponse<IGetChartResponse> {
  statusCode: 200;
}

export interface IGetChartResponse400 extends IModelResponse<IGetChartResponseError> {
  statusCode: 400;
}

export interface IGetChartResponse {
  /** Данные для блока над графиком. Процент, тренд и текст **/
  block?: IBlockSchema | null;
  /** Данные для отрисовки графика **/
  chart?: IChartSchema | null;
}

export interface IGetChartResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetChartResponse | IGetChartResponseError;

export enum ECategory {
  /** Аренда в коммерческой **/
  CommercialRent = 'commercialRent',
  /** Продажа в коммерческой **/
  CommercialSale = 'commercialSale',
  /** Посуточная аренда квартир **/
  DailyFlatRent = 'dailyFlatRent',
  /** Долгосрочная квартир **/
  FlatRent = 'flatRent',
  /** Продажа квартир во вторичке **/
  FlatSale = 'flatSale',
  /** Продажа квартир в новостройках **/
  NewBuildingFlatSale = 'newBuildingFlatSale',
  /** Аренда в загородной **/
  SuburbanRent = 'suburbanRent',
  /** Продажа в загородной **/
  SuburbanSale = 'suburbanSale',
}

export enum EGeoName {
  /** Ленинградская область **/
  Lo = 'lo',
  /** Московская область **/
  Mo = 'mo',
  /** Москва **/
  Msk = 'msk',
  /** Прочие регионы **/
  Other = 'other',
  /** Санкт-Петербург **/
  Spb = 'spb',
}

export enum EDataType {
  /** Спрос **/
  Demand = 'demand',
  /** Ставка по ипотеке **/
  MortgageRate = 'mortgageRate',
  /** Цены **/
  Prices = 'prices',
  /** Предложение **/
  Supply = 'supply',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetChartResponse): TResponse200;
  400(response: IGetChartResponseError): TResponse400;
}
